// extracted by mini-css-extract-plugin
export var label = "_jq-2";
export var slideContainer = "_jq-0";
export var slider = "_jq-1";